import _ from 'lodash'

/**
 * @var {ApiMiddleware}
 */
let api = {}

const DATA_TYPES = {
    'messages': [],
    'data': [
        {
            'id': 'STATIC_STRING',
        },
        {
            'id': 'DATE',
        },
        {
            'id': 'LINK_USER',
        },
        {
            'id': 'LINK_PERSON_RESOURCE',
        },
        {
            'id': 'LINK_THING_RESOURCE',
        },
        {
            'id': 'LINK_PLACE_RESOURCE',
        },
        {
            'id': 'BOOLEAN',
        },
        {
            'id': 'NUMERIC',
        },
        {
            'id': 'DATE_TIME',
        },
        {
            'id': 'URL',
        },
        {
            'id': 'LINK',
        },
        {
            'id': 'ENUM',
        },
        {
            'id': 'COLOR',
        },
        {
            'id': 'LONGTEXT',
        },
        {
            'id': 'ENTITY_STATE',
        },
    ],
}


/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setDataTypeApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        projects: [],
    },
    getters: {
        dataTypes: state => state.projects,
        dataTypeById: state => id => _.find(state, ['id', id]),
    },
    mutations: {
        setDataTypes: (state, projects) => {
            state.projects = projects
        },
    },
    actions: {
        async dataTypesLoad({ commit }) {
            commit('setDataTypes', DATA_TYPES.data)
            return DATA_TYPES.data
        },
    },
})
